import { useQuery, useQueryClient } from "react-query"
import { getEstimatesReportData } from "./estimatesReportApi"

export const useEstimatesReportDataQuery = (startDate?: string, endDate?: string) => {
  return useQuery(['estimatesReport', startDate, endDate], {
    queryFn: () => getEstimatesReportData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}

export const useEstimatesReportInvalidator = () => {
  const queryClient = useQueryClient()
  return {
    invalidate: () => queryClient.invalidateQueries(['estimatesReport'])
  }
}
